<app-icon-button
  iconLigature="share"
  [matMenuTriggerFor]="shareMenu"
  [ariaHideLigature]="true"
  [tooltipText]="'common.share' | translate"
>
</app-icon-button>

<mat-menu #shareMenu>
  <app-share-menu [include]="include" [description]="description" [title]="title" [url]="url"></app-share-menu>
</mat-menu>
